import React, { useEffect, useState } from "react";
import { changeStatusTherapeuticGroup, deleteTherapeuticGroup, getTherapeuticGroups } from "../../../../api/therapeuticGroup";
import { alertError, alertSuccess } from "../../../../utils/logger";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import Table, { buttonsStyle } from "../../../components/tables/table";
import { Button, Tooltip } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import ToggleOffIcon from "@material-ui/icons/ToggleOff";
import ToggleOnIcon from "@material-ui/icons/ToggleOn";
import DeleteIcon from "@material-ui/icons/Delete";
import { Card, CardBody, CardHeader, CardHeaderToolbar } from "../../../../_metronic/_partials/controls";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";

export default function TherapeuticGroupPage() {
    const history = useHistory();
    const user = useSelector((store) => store.authentication?.user, shallowEqual);
    const [therapeuticGroups, setTherapeuticGroups] = useState([]);
    const [therapeuticGroup, setTherapeuticGroup] = useState(null);
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [refresh, setRefresh] = useState(false);

    useEffect(() => {
        setRefresh(false);
    }, [refresh])

    useEffect(() => {
        fetch();
    }, [])

    function fetch() {
        getTherapeuticGroups()
            .then((res) => {
                setTherapeuticGroups(res.data);
            })
            .catch((error) => {
                if (error.request.status !== 404) {
                    alertError({
                        error,
                        customMessage: "No se han encontrado grupos terapéuticos."
                    })
                }
            })
    }

    const columns = [
        { dataField: "fullName", text: "nombre", sort: true },
        {
            dataField: "_id",
            text: "",
            formatter: buttonFormatter,
            align: 'right',
            headerStyle: { width: '200px' }
        },
    ];

    function buttonFormatter(cell) {
        const elem = therapeuticGroups.find((item) => item._id === cell);

        return (
        <>
            <Tooltip title="Editar">
            <Button
                style={buttonsStyle}
                size="small"
                onClick={() => history.push("/edit-therapeutic-group/" + elem._id)}
            >
                <EditIcon />
            </Button>
            </Tooltip>
            {user?.isAdmin && (
            <>
                <Tooltip title={elem?.active ? "Desactivar" : "Activar"}>
                <Button
                    style={buttonsStyle}
                    size="small"
                    onClick={() => {
                        setTherapeuticGroup(elem);
                        setOpenConfirmDialog(1);
                    }}
                >
                    {elem?.active ? (
                    <ToggleOffIcon />
                    ) : (
                    <ToggleOnIcon style={{ color: "red" }} />
                    )}
                </Button>
                </Tooltip>
                <Tooltip title="Borrar">
                <Button
                    style={buttonsStyle}
                    size="small"
                    onClick={() => {
                        setTherapeuticGroup(elem);
                        setOpenConfirmDialog(2);
                    }}
                >
                    <DeleteIcon />
                </Button>
                </Tooltip>
            </>
            )}
        </>
        );
    }

    return  (
        <Card>
            <CardHeader title="Grupos terapéuticos">
                <CardHeaderToolbar>
                <button
                    type="button"
                    className="btn btn-primary text-white"
                    onClick={() => history.push("/edit-therapeutic-group")}
                >
                    Añadir
                </button>
                </CardHeaderToolbar>
            </CardHeader>
            <CardBody>
                { !refresh && (
                    <Table data={therapeuticGroups} columns={columns} />
                )}
            </CardBody>
            <ConfirmDialog
                title={`Seguro que quieres ${therapeuticGroup?.active ? 'deshabilitar' : 'habilitar'} este grupo terapéutico?`}
                open={openConfirmDialog === 1}
                setOpen={setOpenConfirmDialog}
                onConfirm={() => {
                    changeStatusTherapeuticGroup(therapeuticGroup._id, !therapeuticGroup?.active)
                        .then((res) => {
                            if (res.status === 200) {
                                alertSuccess({ title: `${therapeuticGroup?.active ? 'Deshabilitado!' : 'Habilitado!'}`, customMessage: `Admin ${therapeuticGroup?.active ? 'deshabilitado' : 'habilitado'} correctamente` })
                                fetch();
                                setRefresh(true);
                            }
                        })
                        .catch((error) => {
                            alertError({ error: error, customMessage: `No se ha podido ${therapeuticGroup?.active ? 'deshabilitar' : 'habilitar'} el grupo terapéutico.` })
                        });
                }}
            />
            <ConfirmDialog
                title={'Seguro que quieres eliminar este grupo terapéutico?'}
                open={openConfirmDialog === 2}
                setOpen={setOpenConfirmDialog}
                onConfirm={() => {
                    deleteTherapeuticGroup(therapeuticGroup?._id)
                        .then((res) => {
                            if (res.status === 204 || res.status === 200) {
                                alertSuccess({
                                    title: 'Eliminado!',
                                    customMessage: 'Grupo eliminado correctamente.',
                                });
                                fetch();
                                setRefresh(true);
                            }
                        })
                        .catch((error) => {
                            alertError({
                                error: error,
                                customMessage: 'No se ha podido eliminar el grupo.',
                            });
                        });
                }}
            />
        </Card>
    )
} 